module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    attrs: {
      "id": "intercom-element"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "mv4-l mv2"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-wrap justify-evenly content"
  }, [_c('div', {
    staticClass: "w-30-l pa4 bg-white account-card mb4-l mb4-m pointer",
    on: {
      "click": _vm.openIntercomChat
    }
  }, [_vm._m(2)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "w-30-l empty-card pa4 bg-white mb4-l mb4-m mb0 o1"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-end"
  }, [_c('span', {
    staticClass: "f2 b title-responsive ml4-ns"
  }, [_vm._v("Contact Us")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mv2"
  }, [_c('div', {
    staticClass: "mv2 br1 flex justify-between f6"
  }, [_c('div', {
    staticClass: "ml4-ns fw2 mid-gray inter"
  }, [_c('span', [_vm._v("\n          Please note that our operating hours are Monday-Friday, 7am-5pm Pacific.\n        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "responsive-card"
  }, [_c('img', {
    staticClass: "mr1 mb1",
    attrs: {
      "alt": "",
      "src": require("../../static/appicons/Contactus.svg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column justify-center text-responsive"
  }, [_c('h4', {
    staticClass: "mb2 cera-round-pro-medium fw1"
  }, [_vm._v("Online Chat & FAQs")]), _vm._v(" "), _c('span', {
    staticClass: "f6 inter"
  }, [_vm._v("Get quick help")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-30-l pa4 bg-white account-card mb4-l mb4-m mb0 pointer"
  }, [_c('a', {
    staticClass: "no-underline dib-ns",
    attrs: {
      "href": "mailto:support@getakko.com"
    }
  }, [_c('div', {
    staticClass: "responsive-card"
  }, [_c('img', {
    staticClass: "mr1 mb1",
    attrs: {
      "alt": "",
      "src": require("../../static/appicons/Help.svg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column justify-center text-responsive"
  }, [_c('h4', {
    staticClass: "mb2 cera-round-pro-medium fw1"
  }, [_vm._v("Email")]), _vm._v(" "), _c('span', {
    staticClass: "f6 inter"
  }, [_vm._v("support@getakko.com")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-30-l pa4 bg-white account-card mb4-l mb4-m mb0 pointer"
  }, [_c('a', {
    staticClass: "no-underline dib-ns",
    attrs: {
      "href": "https://akko.link/Text-us",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('div', {
    staticClass: "responsive-card"
  }, [_c('img', {
    staticClass: "mr1 mb1",
    attrs: {
      "alt": "",
      "src": require("../../static/appicons/Help.svg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column justify-center text-responsive"
  }, [_c('h4', {
    staticClass: "mb2 cera-round-pro-medium fw1"
  }, [_vm._v("Send a Text")]), _vm._v(" "), _c('span', {
    staticClass: "f6 inter"
  }, [_vm._v("Message us on your own time")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4da1ba58","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactPage.vue
// module id = 1527
// module chunks = 0